var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 91,
    viewBox: "0 0 78 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1474_13870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 24H6V86H71V24Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 12H9V23H27V12Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 22H20V29H56V22Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 11H12V20H67V11Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4402 33.9099H61.2002V39.5599H68.4402V33.9099Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 18H67V83H73V18Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 1H17V19H60V1Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3802 5.81982H49.6802V11.3298H60.3802V5.81982Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 68H61V84H77V68Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 73H55V84H75V73Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 79H50V85H77V79Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6101 5.82007H17.1001V11.3301H27.6101V5.82007Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9698 39.5901H5.31982V45.2401H10.9698V39.5901Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 17H55V34H69V17Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5498 33.9099H5.31982V39.5999H16.5498V33.9099Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2001 22.6201H33.3101V28.3201H39.2001V22.6201Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17H5V53H21V17Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1998 33.9099H16.5498V41.6699H61.1998V33.9099Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6899 39.5901H10.9399V67.5301H66.6899V39.5901Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3798 45.24H5.31982V68.02H11.3798V45.24Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2 66.6899H10.71V73.7499H61.2V66.6899Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3898 73.0801H16.5498V79.2201H55.3898V73.0801Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.16 78.98H22V84.73H50.16V78.98Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 68H1V85H11V68Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 74H6V85H17V74Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 79H7V85H22V79Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 0H17V6H61V0Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 22H72V85H78V22Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 84H5V90H73V84Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 23H0V85H6V23Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16H4V23H11V16Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11H7V18H14V11Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1098 5.82007H11.5498V11.3301H17.1098V5.82007Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8899 5.82007H60.3799V11.3301H65.8899V5.82007Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 10H64V17H70V10Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1502 16.9099H68.4502V22.6099H74.1502V16.9099Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 22H39V29H45V22Z",
    fill: "#FAF0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 20H21V29H33V20Z",
    fill: "#FAF0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 17H21V23H56V17Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4401 44.77H18.8901V46.94H23.4401V44.77Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4401 44.53H18.8901V44.78H23.4401V44.53Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8801 44.53H18.6401V46.94H18.8801V44.53Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6799 44.77H23.4399V46.94H23.6799V44.77Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6799 44.53H23.4399V44.77H23.6799V44.53Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8799 44.53H18.6299V44.78H18.8799V44.53Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6301 44.78H26.0801V46.95H30.6301V44.78Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6301 44.53H26.0801V44.78H30.6301V44.53Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0598 44.54H25.8198V46.95H26.0598V44.54Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8601 44.78H30.6201V46.92H30.8601V44.78Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8801 44.53H30.6201V44.78H30.8801V44.53Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8302 46.95H23.6802V49.31H25.8302V46.95Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0299 46.95H30.8799V54.11H33.0299V46.95Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.63 46.95H16.48V54.11H18.63V46.95Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6402 54.1101H28.4702V56.3101H30.6402V54.1101Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.24 56.53H26.04V58.73H28.24V56.53Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8399 58.9099H23.6699V61.1499H25.8399V58.9099Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.46 56.53H21.29V58.73H23.46V56.53Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0401 54.1101H18.8701V56.3101H21.0401V54.1101Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8801 46.95H18.6401V56.5299H18.8801V46.95Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8801 46.95H30.6201V56.5299H30.8801V46.95Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2901 56.3101H18.8701V56.5301H21.2901V56.3101Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.46 58.73H21.04V58.95H23.46V58.73Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.06 61.1501H23.46V61.3701H26.06V61.1501Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2399 58.73H25.9399V58.95H28.2399V58.73Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.67 58.9099H23.46V61.1499H23.67V58.9099Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0401 58.8401H25.8301V61.1501H26.0401V58.8401Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4697 54.1101H28.2397V58.9501H28.4697V54.1101Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6699 46.95H18.8799V54.11H23.6699V46.95Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8299 49.3201H23.6699V58.7101H25.8299V49.3201Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2398 51.74H25.8198V56.53H28.2398V51.74Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6197 51.74H28.2397V54.11H30.6197V51.74Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.76 54.1101H21.29V56.3101H23.76V54.1101Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2401 49.3201H26.0801V51.7401H28.2401V49.3201Z",
    fill: "#C91C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.67 56.3101H21.29V56.5301H23.67V56.3101Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0498 56.53H25.8198V58.91H26.0498V56.53Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8399 58.71H23.6699V58.93H25.8399V58.71Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.68 56.53H23.46V58.93H23.68V56.53Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0698 49.3201H25.8198V51.8501H26.0698V49.3201Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0698 46.95H25.8198V49.32H26.0698V46.95Z",
    fill: "#917886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2398 46.95H26.0698V49.32H28.2398V46.95Z",
    fill: "#F49EC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6002 49.5701H28.4702V51.5001H30.6002V49.5701Z",
    fill: "#F49EC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6202 46.95H28.4702V49.32H30.6202V46.95Z",
    fill: "#FCEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4697 46.95H28.2397V49.31H28.4697V46.95Z",
    fill: "#F9DBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4697 49.3201H28.2397V51.7401H28.4697V49.3201Z",
    fill: "#DC6F8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6202 49.3201H28.4702V49.5701H30.6202V49.3201Z",
    fill: "#F6B2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6202 51.5H28.4702V51.74H30.6202V51.5Z",
    fill: "#EC83A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.29 54.1101H21.04V56.3101H21.29V54.1101Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.29 56.53H21.04V58.73H21.29V56.53Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6402 56.3101H28.4702V56.5301H30.6402V56.3101Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6799 44.8H45.1299V46.9701H49.6799V44.8Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6799 44.55H45.1299V44.8H49.6799V44.55Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1199 44.5601H44.8799V46.9701H45.1199V44.5601Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9202 44.8H49.6802V46.9701H49.9202V44.8Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9202 44.5601H49.6802V44.8001H49.9202V44.5601Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1299 44.55H44.8799V44.8H45.1299V44.55Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8698 44.8H52.3198V46.9701H56.8698V44.8Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8698 44.55H52.3198V44.8H56.8698V44.55Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3098 44.5601H52.0698V46.9701H52.3098V44.5601Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1101 44.8H56.8701V46.94H57.1101V44.8Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1301 44.55H56.8701V44.8H57.1301V44.55Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0699 46.97H49.9199V49.33H52.0699V46.97Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2799 46.97H57.1299V54.13H59.2799V46.97Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.88 46.97H42.73V54.13H44.88V46.97Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8902 54.1301H54.7202V56.3301H56.8902V54.1301Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.49 56.55H52.29V58.75H54.49V56.55Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0802 58.9399H49.9102V61.1799H52.0802V58.9399Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.71 56.55H47.54V58.75H49.71V56.55Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2901 54.1301H45.1201V56.3301H47.2901V54.1301Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1199 46.97H44.8799V56.55H45.1199V46.97Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1301 46.97H56.8701V56.55H57.1301V46.97Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5401 56.3401H45.1201V56.5601H47.5401V56.3401Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.71 58.75H47.29V58.97H49.71V58.75Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.31 61.1702H49.71V61.3902H52.31V61.1702Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4899 58.75H52.1899V58.97H54.4899V58.75Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.92 58.9399H49.71V61.1799H49.92V58.9399Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2901 58.8601H52.0801V61.1701H52.2901V58.8601Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7197 54.1301H54.4897V58.9701H54.7197V54.1301Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9199 46.97H45.1299V54.13H49.9199V46.97Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0702 49.3401H49.9102V58.7301H52.0702V49.3401Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4898 51.76H52.0698V56.55H54.4898V51.76Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8697 51.76H54.4897V54.13H56.8697V51.76Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.01 54.1301H47.54V56.3301H50.01V54.1301Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4798 49.3401H52.3198V51.7601H54.4798V49.3401Z",
    fill: "#C91C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.92 56.3401H47.54V56.5601H49.92V56.3401Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2998 56.55H52.0698V58.93H52.2998V56.55Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0802 58.73H49.9102V58.95H52.0802V58.73Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.93 56.55H49.71V58.9501H49.93V56.55Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3198 49.3401H52.0698V51.8701H52.3198V49.3401Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3198 46.97H52.0698V49.34H52.3198V46.97Z",
    fill: "#917886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4898 46.97H52.3198V49.34H54.4898V46.97Z",
    fill: "#F49EC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8502 49.5901H54.7202V51.5201H56.8502V49.5901Z",
    fill: "#F49EC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8702 46.97H54.7202V49.34H56.8702V46.97Z",
    fill: "#FCEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7197 46.97H54.4897V49.33H54.7197V46.97Z",
    fill: "#F9DBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7197 49.3401H54.4897V51.7601H54.7197V49.3401Z",
    fill: "#DC6F8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8702 49.3401H54.7202V49.5901H56.8702V49.3401Z",
    fill: "#F6B2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8702 51.52H54.7202V51.76H56.8702V51.52Z",
    fill: "#EC83A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.54 54.1301H47.29V56.3301H47.54V54.1301Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.54 56.55H47.29V58.75H47.54V56.55Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8902 56.3401H54.7202V56.5601H56.8902V56.3401Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8802 60.04H29.4302V64.83H31.8802V60.04Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0604 62.4399H36.6704V64.8299H39.0604V62.4399Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0101 60.04H43.5601V64.83H46.0101V60.04Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6704 64.8301H31.8804V67.1301H36.6704V64.8301Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5501 64.8301H39.0601V67.1301H43.5501V64.8301Z",
    fill: "#221E1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1474_13870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.76,
    height: 90.48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlum);
export default __webpack_public_path__ + "static/media/Plum.14dbf13f96a4d2be8e09380cf01c615c.svg";
export { ForwardRef as ReactComponent };